// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__CZbkK","ant-page-header-heading-title":"styles_ant-page-header-heading-title__vAIeo","table":"styles_table__3nzwR"};